import type { IClientConfig } from '@/types';
import { defineStore } from 'pinia';

export const useConfigStore = defineStore('config', () => {
    const config = ref<IClientConfig | null>(null);
    const isLivings = ref(false);

    function setConfig(configObj: IClientConfig) {
        config.value = configObj;
    }

    function setIsLivings(value: boolean) {
        isLivings.value = value;
    }

    return { config: computed(() => config.value), isLivings: computed(() => isLivings.value), setConfig, setIsLivings };
});
